import React from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from './components';
import App from './App';
import './index.scss';

const root = createRoot(document.getElementById('root'));

/**
 * @desc React Entry point.
 */
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
